import { defineAction } from '~/prix'
import synchronizeOlapGeoAction from './geoSynchronizeOlapGeo.action.json' with { type: 'json' }
import { z } from 'zod'

const synchronizeOlapGeoDefinition = defineAction({
  ...synchronizeOlapGeoAction,

  input: z.object({}),
  output: z.object({}),
})

export default synchronizeOlapGeoDefinition
